// extracted by mini-css-extract-plugin
export default {"typingContainer":"loading_typingContainer__XJ-SI","dot":"loading_dot__n+QyO","blink":"loading_blink__BV+Rg","messageRow":"loading_messageRow__ASFru","left":"loading_left__3sawQ"};